var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchiveAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5209 2H7.47921C5.26046 2 3.45837 3.74 3.45837 5.86V19.95C3.45837 21.75 4.80212 22.51 6.44796 21.64L11.5313 18.93C12.073 18.64 12.948 18.64 13.4792 18.93L18.5625 21.64C20.2084 22.52 21.5521 21.76 21.5521 19.95V5.86C21.5417 3.74 19.7396 2 17.5209 2ZM15.1042 11.4H13.2813V13.21C13.2813 13.62 12.9271 13.96 12.5 13.96C12.073 13.96 11.7188 13.62 11.7188 13.21V11.4H9.89587C9.46879 11.4 9.11462 11.06 9.11462 10.65C9.11462 10.24 9.46879 9.9 9.89587 9.9H11.7188V8.21C11.7188 7.8 12.073 7.46 12.5 7.46C12.9271 7.46 13.2813 7.8 13.2813 8.21V9.9H15.1042C15.5313 9.9 15.8855 10.24 15.8855 10.65C15.8855 11.06 15.5313 11.4 15.1042 11.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveAdd);
export default __webpack_public_path__ + "static/media/archive-add.0fdc6c984eb6c7b4a7c5dee9c628b793.svg";
export { ForwardRef as ReactComponent };